import { IPropsButtonSecunday } from "interfaces/IPropsButton"
import { ButtonSecondaryStyled } from "theme/common/Button.styled"
import { IconCheck } from "theme/common/Icon.styled"

const ButtonOptionCalendar = ({ text, active, onclick, id }: IPropsButtonSecunday) => {
  return (
    <ButtonSecondaryStyled onClick={onclick} active={active} id={id.toString()}>
      {active && <IconCheck className="icon" />}
      {text}
    </ButtonSecondaryStyled>
  )
}

export default ButtonOptionCalendar
